import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import DiscoverGreenMark from './components/DiscoverGreenMark';
import AboutUs from './components/AboutUs';
import WhyChooseUs from './components/WhyChooseUs';
import Clients from './components/Clients';
import CallBackForm from './components/CallBackForm';
import Footer from './components/Footer';
import About from './components/About';
import CourseDetails from './components/CourseDetails';
import EnrollPage from './components/EnrollPage';
import RegisterPage from './components/EnrollmentMain';
import CourseRegister from './components/CourseRegister';
import CoursesPage from './components/CoursesPage';
import ContactUs from './components/contactus';
import AlumniPage from './components/AlumniPage';
import EnrollmentMain from './components/EnrollmentMain';
import EnhancedR1Page from './components/EnhancedR1Page';
import EmailPDFGenerator from './components/CompanySponsored/EmailPDFGenerator';
import Blog from './components/blog/blog';
import ApiCourses from './components/ApiCourses';
import PrivacyPolicy from './components/PrivacyPolicy';

import SEO from './components/SEO';

function HomePage() {
  return (
    <div className="bg-white text-gray-900 font-sans overflow-x-hidden scroll-smooth">
      <SEO 
        title="Home" 
        description="Greenmark is Singapore's leading ITE-approved training provider for PCM sector competency training, including Metal Scaffolding, Electrical Fitting, and more."
        keywords="Greenmark, ITE Approved Training, PCM Sector, Singapore Industrial Training, Metal Scaffolding Course, Electrical Fitting Course"
      />
      <Navbar />
      <section id="home">
        <Hero />
      </section>
      <section id="courses">
        <Services />
      </section>
      <section id="training">
        <DiscoverGreenMark />
      </section>
      <section id="about">
        <AboutUs />
        <WhyChooseUs />
        {/* <Clients /> */}
      </section>
      <section id="contact">
        <CallBackForm />
      </section>
      <Footer />
    </div>
  );
}

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showChatWidget, setShowChatWidget] = useState(false);

  // Show/hide scroll to top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close modal on ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowChatWidget(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />

        <Route path="/courses" element={<CoursesPage />} />
        <Route path='contact' element={<ContactUs />} />
        <Route path='alumni' element={<AlumniPage />} />
        <Route path='/demo' element={<EmailPDFGenerator />} />
        <Route path="/course-details/:id" element={<CourseDetails />} />
        <Route path="/enroll" element={<EnrollPage />} />
        <Route path="/register" element={<EnrollmentMain />} />
        <Route path='/enhanced-r1' element={<EnhancedR1Page />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/api-courses' element={<ApiCourses />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />

        {/* <Route path='/enhanced-registration' element={<EnhancedRegistration />} />
        <Route path='/registration-demo' element={<RegistrationDemo />} /> */}
      </Routes>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <motion.button
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: "spring", damping: 20 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-6 bg-[#0b9949] text-white p-4 rounded-full shadow-2xl hover:bg-[#087a38] transition-all z-50 hover:scale-110"
          title="Scroll to top"
        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </motion.button>
      )}

      {/* WhatsApp Chat Widget Button */}
      {!showChatWidget && (
        <motion.button
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1, type: "spring" }}
          onClick={() => setShowChatWidget(true)}
          className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#20BA5A] transition-all z-50 hover:scale-110"
        >
          <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </motion.button>
      )}

      {/* Chat Widget */}
      {showChatWidget && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: "spring", damping: 20 }}
          className="fixed bottom-6 right-6 w-[90vw] max-w-sm shadow-2xl rounded-2xl overflow-hidden z-50"
        >
          {/* Header */}
          <div className="bg-[#25D366] px-4 py-3 flex justify-between items-center">
            <div className="flex items-center gap-3">
              {/* Avatar Circle with Logo */}
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-md overflow-hidden">
                <img src="/logo.png" alt="Greenmark Logo" className="w-7 h-7 object-cover" />
              </div>
              {/* Company Name & Badge */}
              <div>
                <div className="flex items-center gap-1.5">
                  <span className="text-white font-semibold text-base">Greenmark</span>
                  {/* Verification Tick */}
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="text-white text-xs font-light opacity-90">
                  Active
                </div>
              </div>
            </div>
            <button
              onClick={() => setShowChatWidget(false)}
              className="w-8 h-8 rounded-full bg-black bg-opacity-20 flex items-center justify-center text-white hover:bg-opacity-30 transition-colors"
            >
              <span className="text-xl font-bold">×</span>
            </button>
          </div>

          {/* Chat Body */}
          <div className="bg-white p-6 h-64 flex flex-col justify-between">
            {/* Message Bubble */}
            <div className="relative max-w-xs">
              <div className="bg-gray-100 text-gray-800 rounded-xl rounded-bl-sm p-4 shadow-sm">
                <p className="font-medium">Hello</p>
                <p className="text-sm">Can we help you?</p>
              </div>
              <div className="absolute bottom-0 left-0 -ml-1 w-4 h-4 transform rotate-45 bg-gray-100" style={{ clipPath: "polygon(0 0, 100% 100%, 0 100%)" }}></div>
            </div>

            {/* Open Chat Button */}
            <div className="flex justify-end">
              <a
                href="https://wa.me/6580147799?text=Hi%20Greenmark"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white font-medium py-3 px-6 rounded-full flex items-center gap-2 shadow-md hover:bg-[#20BA5A] transition-all hover:scale-105"
              >
                <span>Open chat</span>
                <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
}

export default App;
